export default "__VITE_ASSET__pNF2Nxm$__"